module.exports = __webpack_public_path__ + "static/img/baopinquan.fd391ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/baopinquan.jpg
// module id = 4gWo
// module chunks = 128